import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { ArrowRight } from "@bw/icons"
import { useTranslation } from "react-i18next"
import { Link } from "gatsby"

const PharmacyWrapper = styled.div`
  text-decoration: none;
  color: var(--font-color);

  a {
    text-decoration: none;
  }
`

const Address = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 23px;
  color: #232825;
`

const Itinerary = styled.a`
  display: flex;
  align-items: center;
  margin-top: 7px;
  gap: 7px;
  font-weight: 700;
  font-size: 15px;
  line-height: 176.3%;
`

const More = styled.div`
  display: flex;
  align-items: center;
  margin-top: 7px;
  gap: 7px;
  font-weight: 700;
  font-size: 15px;
  line-height: 176.3%;
`

const Title = styled.h4`
  font-family: "Ginto", georgia, serif;
  font-weight: 500;
  font-size: 17px;
  margin: 0 0 7px;
`

const Distance = styled.div`
  font-size: 14px;
`

const Pharmacy = props => {
  const { t } = useTranslation()

  const geolocalization = encodeURIComponent(
    `${props.pharmacyTitle}, ${props.street}, ${props.npa} ${props.city}`
  )

  return (
    <PharmacyWrapper className="pharmacyTeaser">
      <Link to={props.pharmacyLink}>
        <Title>{props.pharmacyTitle}</Title>
        <Address>
          {props.street}
          <br />
          {props.npa}&nbsp;
          {props.city}
          {props.distance && (
            <Distance>
              à&nbsp;{props.distance.toFixed(1).replace(".0", "")}km
            </Distance>
          )}
        </Address>
        {props.more && (
          <More>
            <ArrowRight />
            En savoir plus
          </More>
        )}
      </Link>
      {props.showItinerary && (
        <Itinerary
          href={`https://www.google.ch/maps/dir//${geolocalization}`}
          target="_blank"
          rel="noreferrer"
        >
          <ArrowRight />
          {t("itinerary")}
        </Itinerary>
      )}
    </PharmacyWrapper>
  )
}

Pharmacy.propTypes = {
  pharmacyTitle: PropTypes.string,
  pharmacyLink: PropTypes.string,
  street: PropTypes.string,
  npa: PropTypes.number,
  city: PropTypes.string,
  distance: PropTypes.number,
  more: PropTypes.bool,
}

Pharmacy.defaults = {
  showItinerary: true,
  more: false,
}

export { Pharmacy }
